module.exports = __webpack_public_path__ + "img/Dantam Bridal 20.0635086c.jpg";